import { Pipe, PipeTransform } from '@angular/core';

import { phoneFormatter } from './phone.formatter';

/**
 * @ngdoc pipe
 * @name ApPhonePipe
 *
 * @deprecated - use `@ap/pipes` instead
 *
 * @description
 * Format a phone number for display. Phone numbers will be formatted in the following way:
 * - "06 - 12 34 56 78" (Dutch mobile number)
 * - "040 - 123 45 67" (Dutch number)
 * - "+32 12 34 56 78" (Foreign number)
 */

@Pipe({
    name: 'apPhone'
})
export class ApPhonePipe implements PipeTransform {
    public transform(phone: string): string {
        return phone ? phoneFormatter.formatDisplay(phone) : phone;
    }
}
